<template>
  <div class="contaniner">
    <!-- <i name="tabs" class="el-icon-d-arrow-left" @click="leftmove"></i> -->
    <img
      class="el-icon-d-arrow-left"
      src="../assets/icon/icon_qian_nor.png"
      style="width: 32px; height: 32px"
      @click="leftmove"
    />
    <div
      class="toolbar"
      :style="{
        width: getToolData.length * 130 + 'px',
        'margin-left': xxx * 100 + 'px',
      }"
    >
      <!-- //左箭头 -->
      <!-- <el-tag
        class="toolItem"
        type="info"
        :disable-transitions="false"
        :closable="item.id != 0"
        effect="plain"
        v-for="(item, index) in getToolData"
        :key="index"
        :class="{ active: $route.path == item.detail }"
        @click="redirect(item)"
        @close="closeToolItem(item, index)"
      >
        <span class="dot" v-if="$route.path == item.detail"></span>
        {{ item.name }}
      </el-tag> -->
      <div style="display: flex">
        <div
          v-for="(item, index) in getToolData"
          :key="index"
          class="toolbar-item"
        >
          <div
            :class="[$route.path == item.detail || routeIndex == index ? 'activeItem' : 'item']"
            @click="redirect(item)"
            @mouseenter="moveFn($event,index)"
            @mouseleave="leaveFn($event,index)"
          >
            {{ item.name }}
          </div>
          <i
            @click="closeToolItem(item, index)"
            :class="{ active: $route.path == item.detail || routeIndex == index }"
            class="el-icon-circle-close"
            style="
              position: absolute;
              top: 4px;
              right: -8px;
              background: white;
              z-index: 999;
            "
          ></i>
        </div>
      </div>
    </div>
    <!-- <i
      @click="closeAll(item)"
      class="el-icon-circle-close"
      style="position: absolute; right: 26px; top: 8px"
    ></i> -->
    <!-- <i name="tabs" class="el-icon-d-arrow-right" @click="rightmove"></i> -->
    <img
      class="el-icon-d-arrow-right"
      src="../assets/icon/icon_hou_nor.png"
      style="width: 32px; height: 32px"
      @click="rightmove"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "tabar",
  data () {
    return {
      xxx: 0,
      routeIndex: null,
      isLogistics: JSON.parse(sessionStorage.getItem("limit")).menuTreeList[0]
        .name,
    };
  },
  computed: {
    ...mapGetters(["getToolData", "getCacheView"]),
  },
  created () {
    console.log('00000')
  },
  updated () {
    if (!this.getToolData.length && this.isLogistics == "首页") {
      this.$router.push({ path: "/home" });
    } else if (!this.getToolData.length && this.isLogistics == "物流首页") {
      this.$router.push({ path: "/logisticsIndex" });
    } else if (!this.getToolData.length && this.isLogistics == "会员首页") {
      this.$router.push({ path: "/dashboard" });
    }
  },
  methods: {
    leaveFn(e,idx){
      console.log(idx)
      this.routeIndex = null
    },
    moveFn(e,idx){
      console.log(idx)
      this.routeIndex = idx;
    },
    leftmove () {
      if (this.xxx < 0) {
        this.xxx += 1;
      }
    },
    rightmove () {
      if (this.getToolData.length > 6) {
        if (this.xxx > -(this.getToolData.length + this.xxx)) {
          this.xxx -= 1;
        }
      }
    },
    closeToolItem (item, index) {
      let tempIndex = this.getToolData.findIndex((v) => {
        if (this.$route.fullPath.indexOf("?") != -1) {
          return this.$route.fullPath.split("?")[0] == v.detail;
        } else {
          return this.$route.fullPath == v.detail;
        }
      });
      this.$store.dispatch("clearToolBar", item);
      this.$store.dispatch("clearCache", item.componentName);
      if (
        this.getToolData.length >= 1 &&
        this.getToolData.length === tempIndex &&
        tempIndex < index
      ) {
        this.$router.push({
          path: this.getToolData[index - 1].detail,
        });
      } else {
        if (
          this.getToolData.length &&
          !(this.getToolData.length >= tempIndex)
        ) {
          this.$router.push({
            path: this.getToolData[this.getToolData.length - 1].detail,
          });
        }
      }
      if (tempIndex == index && this.getToolData.length >= 1) {
        this.$router.push({
          path: this.getToolData[this.getToolData.length - 1].detail,
        });
      }
    },
    redirect (item) {
      if (item.componentName === "addStorage") {
        this.$store.commit("updateTabStorage", true);
      }

      this.$router.push({ path: item.detail });
    },
    closeAll () {
      this.$store.commit("closeTar");
    },
  },
};
</script>

<style scoped lang="scss">
.toolbar {
  width: 100%;
  overflow-x: scroll; /*添加横向滚动条*/
  white-space: nowrap; /*不换行*/
  display: inline-block;
  padding: 0 12px;
  transition: all linear 0.5s;
  padding-left: 44px;
  .toolbar-item {
    position: relative;
    min-width: 96px;
    height: 50px;
    margin-right: 12px;
    .item {
      position: absolute;
      top: 10px;
      left: 0px;
      cursor: pointer;
      width: 100%;
      // height: 32px;
      line-height: 32px;
      // background: #ffffff;
      border: 1px solid #909099;
      border-radius: 3px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #909099;
      text-align: center;
      z-index: 1;
    }
    .close {
      position: absolute;
      top: -16px;
      right: -10px;
      z-index: 999 !important;
      background: white;
    }
  }
}
/* 使用伪类选择器 ::-webkit-scrollbar ,兼容chrome和safari浏览器 */
.toolbar::-webkit-scrollbar {
  display: none;
}
/*兼容火狐*/
.toolbar {
  scrollbar-width: none;
}
/* 兼容IE10+ */
.toolbar {
  -ms-overflow-style: none;
}
/deep/.dot {
  background: #858592;
  width: 6px;
  display: inline-block;
  height: 6px;
  border-radius: 50%;
  margin-right: 3px;
  border: 1px solid transparent;
}
/deep/.el-tag .el-icon-close {
  display: block;
  color: #909399;
}
/deep/.el-tag .el-icon-close {
  color: #909399;
  display: inline-block;
}
/deep/.el-tag--plain.el-tag--info {
  background-color: #fff;
  border: 1px solid transparent;
  text-align: center;
  color: #696c70;
  border: 1px solid #e3e3e3;
  // margin-right: 10px;
}
.activeItem {
  position: absolute;
  top: 10px;
  left: 0px;
  cursor: pointer;
  width: 100%;
  line-height: 32px;
  border: 1px solid #2d46ee;
  border-radius: 3px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2d46ee;
  text-align: center;
  z-index: 1;
}
.active {
  color: #2d46ee;
  // border-top: 1px solid #999 !important;
}
/deep/.el-tag--plain.el-tag--info:hover {
  cursor: pointer;
}
/deep/.el-icon-d-arrow-right {
  position: absolute;
  top: 10px;
  right: 0px;
  background: #fff;
  padding-right: 8px;
  z-index: 100;
}
.el-icon-d-arrow-left {
  position: absolute;
  top: 10px;
  left: 0px;
  background: #fff;
  padding-left: 8px;
  z-index: 100;
}
</style>
